module.exports = __webpack_public_path__ + "img/unassigned.fd63ad28.png";